import { accountHeaders } from "@/lib/account";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function toError(res) {
  const detail = await res.json().then((d) => d.detail).catch(() => null);
  const err = new Error(typeof detail === "string" ? detail : "Richiesta non valida. Controlla i campi e riprova.");
  err.status = res.status;
  return err;
}

function splitEvents(buffer) {
  const parts = buffer.split("\n\n");
  const rest = parts.pop();
  const events = parts.filter((c) => c.startsWith("data: ")).map((c) => JSON.parse(c.slice(6)));
  return { events, rest };
}

function applyEvent(ev, onDelta, state) {
  if (ev.type === "delta") onDelta(ev.text);
  else if (ev.type === "done") state.final = ev;
  else if (ev.type === "error") throw new Error(ev.message);
}

export async function streamSSE(path, body, onDelta) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...accountHeaders() },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw await toError(res);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  const state = { final: null };
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    const { events, rest } = splitEvents(buf + decoder.decode(value, { stream: true }));
    buf = rest;
    events.forEach((ev) => applyEvent(ev, onDelta, state));
  }
  if (!state.final) throw new Error("Risposta incompleta dall'AI. Riprova.");
  return state.final;
}
